import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { I18NextPipe } from 'angular-i18next';
import { ButtonComponent, FormsUtil, InputComponent, MbsPopupType, ModalComponent, ModalFooterDirective, ToastService } from 'mbs-ui-kit';
import { RestoreTargetEnum } from 'mbs-ui-shared@models/cloud-restore';
import { CloudRestorePermissionsRequestService } from 'mbs-ui-shared@services/cloud-restore-permissions-request.service';
import { finalize } from 'rxjs';

@Component({
  selector: 'mbs-cloud-restore-request-permissions',
  imports: [ModalComponent, InputComponent, ReactiveFormsModule, ButtonComponent, I18NextPipe, ModalFooterDirective],
  templateUrl: './request-permissions.component.html'
})
export class RequestPermissionsModalComponent implements OnInit {
  private i18N = inject(I18NextPipe);
  private cloudRestorePermissionsRequestService = inject(CloudRestorePermissionsRequestService);
  private toastService = inject(ToastService);

  public readonly popupType = MbsPopupType;

  public title: string;
  public loading = false;
  public target: RestoreTargetEnum;
  public requestText = new FormControl('', [Validators.required]);

  @ViewChild(ModalComponent, { static: true }) private baseModal: ModalComponent;

  ngOnInit() {
    this.target = this.target ?? this.baseModal.data?.target;
    this.title = this.i18N.transform(this.target === RestoreTargetEnum.Azure ? 'mbs-ui:cloud-restore.azureVM' : 'mbs-ui:cloud-restore.ec2');
  }

  public requestPermissions(): void {
    if (this.requestText.invalid) {
      return void FormsUtil.triggerValidation(this.requestText);
    }

    this.loading = true;
    this.cloudRestorePermissionsRequestService
      .sendPermissionsRequest(this.target, this.requestText.value)
      .pipe(finalize(() => (this.loading = false)))
      .subscribe(() => {
        this.toastService.success();
        this.baseModal.close();
      });
  }
}
